import { render, staticRenderFns } from "./NlCard.vue?vue&type=template&id=36ae5963&scoped=true&"
import script from "./NlCard.vue?vue&type=script&lang=js&"
export * from "./NlCard.vue?vue&type=script&lang=js&"
import style0 from "./NlCard.vue?vue&type=style&index=0&id=36ae5963&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ae5963",
  null
  
)

export default component.exports